<template>
  <img
    v-if="logos.desktop || logos.mobile"
    :src="logos.desktop || logos.mobile"
    class="h-full w-full object-contain"
  />
  <UiIcon v-else icon="logoMain" container-size></UiIcon>
</template>

<script setup lang="ts">
import { useLogos } from '~/composables';

const { logos } = useLogos();
</script>
